import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { generateAxiosInstanceCommon } from '../../hooks/useAuthorizedReuestCommon';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { deleteItem, findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';
import { ZodError } from 'zod';
import { ErrorMessage } from '../../validation/validationError';
import { sectionDssComplainFormValidation } from '../../validation/Validation';

const SectionDssComplain = () => {
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosCommon = generateAxiosInstanceCommon();
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")

    const initialDssData = {
        academicYearMasterId: "",
        teacherMasterId: "",
        studentMasterId: "",
        fromDate: "",
        toDate: ""
    }
    const [dssData, setDssData] = useState(initialDssData);

    const [academicYearList, setAcademicYearList] = useState([]);
    const [teacherList, setTeacherList] = useState([]);
    const [studentList, setStudentList] = useState([]);

    const [dssComplainList, setDssComplainList] = useState([]);
    const [editId, setEditId] = useState(null)

    const [errors, setErrors] = useState([]);

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [titleSort, setTitleSort] = useState(null);
    // const [studentNameSort, setStudentNameSort] = useState(null);
    // const [teacherNameSort, setTeacherNameSort] = useState(null);
    // const [complainedBySort, setComplainedBySort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["title", "dssComplainDetails.studentMasterDetails.studentName", "dssComplainDetails.teacherMasterDetails.teacherName", "dssComplainDetails.complainedBy", "dssComplainDetails.complained"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getAcademicYearList();
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            showComplain();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (dssData.academicYearMasterId) {
                setDssComplainList(await searchArray("B", getApiUrl(), searchKeys, searchValue.trim()));
            }
        }
    }

    // useEffect(() => {
    //     if (saveId) {
    //         const pageNumber = findPageNumber(dailyPresentyList, saveId, itemsPerPage);
    //         setCurrPage(pageNumber);
    //     }
    // }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(dssComplainList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > dssComplainList.length) {
            endIndex = dssComplainList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(dssComplainList.slice(startIndex, endIndex));
    }, [dssComplainList, currPage, itemsPerPage]);

    const getAcademicYearList = () => {
        const apiUrlForSyllabus = `/sections-academic-years?sectionMasterId=${sectionMasterId}`;
        authorizedAxiosCommon && authorizedAxiosCommon.get(apiUrlForSyllabus)
            .then(response => {
                setAcademicYearList(response.data.data)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleAcademicYearChange = (e) => {
        const { name, value } = e.target;
        setDssData((prevData) => {
            return {
                ...prevData,
                [name]: value,
                teacherMasterId: "",
                studentMasterId: "",
                fromDate: "",
                toDate: ""
            }
        })

        const apiUrl1 = `/academic-year-wise-teacher-data?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&academicYearMasterId=${value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl1)
            .then(response => {
                setTeacherList(response.data.result)
            })
            .catch(error => {
                setTeacherList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });

        const apiUrl2 = `/get-academic-year-wise-students?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&academicYearMasterId=${value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl2)
            .then(response => {
                setStudentList(response.data.result)
            })
            .catch(error => {
                setStudentList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });

        if (value.trim().length !== 0) {
            setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        }
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setDssData(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const getApiUrl = () => {
        let apiUrl = `/get-dss-complain-list?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&`;

        if (dssData.teacherMasterId) {
            apiUrl += `teacherMasterId=${dssData.teacherMasterId}&`;
        }
        if (dssData.studentMasterId) {
            apiUrl += `studentMasterId=${dssData.studentMasterId}&`;
        }
        if (dssData.academicYearMasterId) {
            apiUrl += `academicYearMasterId=${dssData.academicYearMasterId}&`;
        }
        if (dssData.fromDate) {
            apiUrl += `fromDate=${dssData.fromDate}&`;
        }
        if (dssData.toDate) {
            apiUrl += `toDate=${dssData.toDate}&`;
        }

        apiUrl = apiUrl.replace(/&$/, ''); // Remove trailing '&' if present
        return apiUrl;
    }

    const showComplain = async (e) => {
        try {
            await sectionDssComplainFormValidation.parseAsync(dssData);
            setErrors([]);
            setLoading(true);
            const response = await authorizedAxiosSection.get(getApiUrl());
            setDssComplainList(response.data.result)
        } catch (error) {
            setDssComplainList([]);
            if (error instanceof ZodError) {
                setErrors(error.errors);
            } else {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            }
        } finally {
            setLoading(false);
        }
    }

    const handleInputReset = () => {
        setDssData(initialDssData);
        setDssComplainList([]);
        setErrors([]);
        setTeacherList([]);
        setStudentList([]);
    }

    // useEffect(() => {
    //     if (titleSort == true || titleSort == false) {
    //         setStudentNameSort(null);
    //         setTeacherNameSort(null);
    //         setComplainedBySort(null);
    //     }
    // }, [titleSort])

    // useEffect(() => {
    //     if (studentNameSort == true || studentNameSort == false) {
    //         setTitleSort(null);
    //         setTeacherNameSort(null);
    //         setComplainedBySort(null);
    //     }
    // }, [studentNameSort])

    // useEffect(() => {
    //     if (teacherNameSort == true || teacherNameSort == false) {
    //         setTitleSort(null);
    //         setStudentNameSort(null);
    //         setComplainedBySort(null);
    //     }
    // }, [teacherNameSort])

    // useEffect(() => {
    //     if (complainedBySort == true || complainedBySort == false) {
    //         setTitleSort(null);
    //         setStudentNameSort(null);
    //         setTeacherNameSort(null);
    //     }
    // }, [complainedBySort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div id='scroll-up'></div>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>DSS Complain</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fas fa-chart-bar"></i>DSS Complain</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="academicYearMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Academic Year:</label>
                                                    <select class="form-select" aria-label="Default select example" name='academicYearMasterId' onChange={handleAcademicYearChange} value={dssData.academicYearMasterId}>
                                                        <option value={''} disabled>Select Year</option>
                                                        {
                                                            academicYearList?.map((year) => {
                                                                return <option value={year.academicYearMasterId}>{year.academicYearMasterDetails.yearName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <ErrorMessage errors={errors} field="academicYearMasterId" />
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="teacherMasterId" className="col-form-label">Select Teacher :</label>
                                                    <select class="form-select" aria-label="Default select example" disabled={editId} name='teacherMasterId' onChange={handleInputChange} value={dssData.teacherMasterId}>
                                                        <option selected value={''} disabled>Select Teacher</option>
                                                        {
                                                            teacherList?.map((teacher) => {
                                                                return <option value={teacher.id}>{teacher.teacherName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {/* {error.teacherMasterId && <p style={{ color: 'red' }}>{error.teacherMasterId}</p>} */}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="studentMasterId" className="col-form-label">Select Student :</label>
                                                    <select class="form-select" aria-label="Default select example" disabled={editId} name='studentMasterId' onChange={handleInputChange} value={dssData.studentMasterId}>
                                                        <option selected value={''} disabled>Select Student</option>
                                                        {
                                                            studentList?.map((student) => {
                                                                return <option value={student.id}>{student.studentName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {/* {error.teacherMasterId && <p style={{ color: 'red' }}>{error.teacherMasterId}</p>} */}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="fromDate" className="col-form-label">From Date:</label>
                                                    <input type="date" className="form-control" id="fromDate" name='fromDate' onChange={handleInputChange} value={setDssData.fromDate} /*min={minDate} max={maxDate}*/ />
                                                    {/* <ErrorMessage errors={errors} field="startDate" /> */}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="toDate" className="col-form-label">To Date:</label>
                                                    <input type="date" className="form-control" id="toDate" name='toDate' onChange={handleInputChange} value={setDssData.toDate} /*min={minDate} max={maxDate}*/ />
                                                    {/* <ErrorMessage errors={errors} field="endDate" /> */}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6 d-flex justify-content-end mt-3">
                                                    <button className="btn btn-primary" type="button" onClick={showComplain}>Show</button>
                                                </div>
                                                <div className="col-md-6 mt-3">
                                                    <button className="btn btn-danger delete_icon delete-icon" type="reset" onClick={handleInputReset}>Reset</button>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope='col'>
                                                                            Title
                                                                            <SortIcon sortState={titleSort} setSortState={setTitleSort} setData={setDssComplainList} setCurrPage={setCurrPage} sortingPath={"title"} />
                                                                        </th>
                                                                        <th scope='col'>
                                                                            Student Name
                                                                            {/* <SortIcon sortState={studentNameSort} setSortState={setStudentNameSort} setData={setDssComplainList} setCurrPage={setCurrPage} sortingPath={"dssComplainDetails.studentMasterDetails.studentName"} /> */}
                                                                        </th>
                                                                        <th scope='col'>
                                                                            Teacher Name
                                                                            {/* <SortIcon sortState={teacherNameSort} setSortState={setTeacherNameSort} setData={setDssComplainList} setCurrPage={setCurrPage} sortingPath={"dssComplainDetails.teacherMasterDetails.teacherName"} /> */}
                                                                        </th>
                                                                        <th scope='col'>
                                                                            Complained By
                                                                            {/* <SortIcon sortState={complainedBySort} setSortState={setComplainedBySort} setData={setDssComplainList} setCurrPage={setCurrPage} sortingPath={"dssComplainDetails.complainedBy"} /> */}
                                                                        </th>
                                                                        <th scope='col'>Complained</th>
                                                                        <th scope="col">Status</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {displayedData?.length > 0 ? (
                                                                        displayedData?.map((dss, index) => (
                                                                            dss?.dssComplainDetails?.map((complain, i) => (
                                                                                <tr key={`${dss.id}-${i}`}>
                                                                                    {i === 0 && (
                                                                                        <>
                                                                                            <th rowSpan={dss.dssComplainDetails.length} scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                            <td rowSpan={dss.dssComplainDetails.length}>{dss?.title}</td>
                                                                                            <td rowSpan={dss.dssComplainDetails.length}>{complain?.studentMasterDetails?.studentName}</td>
                                                                                            {/* <td rowSpan={dss.dssComplainDetails.length}>{dss?.teacherMasterDetails?.teacherName}</td> */}
                                                                                        </>
                                                                                    )}
                                                                                    <td>{complain?.teacherMasterDetails?.teacherName}</td>
                                                                                    <td>{complain?.complainedBy === 'S' ? 'Student' : 'Teacher'}</td>
                                                                                    <td>{complain?.complained}</td>
                                                                                    <td>{complain?.status === 0 ? 'Pending' : 'Resolved'}</td>
                                                                                </tr>
                                                                            ))
                                                                        ))
                                                                    ) : (
                                                                        <tr>
                                                                            <th colSpan={"14"} style={{ textAlign: 'center' }}>No Complain Available</th>
                                                                        </tr>
                                                                    )}
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={dssComplainList.length} />
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default SectionDssComplain;